import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';


import { GasNetworkModel } from '../model/gasNetworkModel';
import { GasStationModel } from '../model/gasStationModel';
import { ResponseModel } from '../model/responseModel';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { GasNetworkTariffModel } from '@core/api';


@Injectable()
export class GasStationsService {

  protected basePath = 'https://localhost/v1';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/renter-form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/renter-form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }


  /**
   *
   * Returns a lsit of gas stations network
   */
  public gasNetworkGet(): Observable<ResponseModel<GasNetworkModel[]>> {
    return this.httpClient.get<ResponseModel<GasNetworkModel[]>>(`${ this.basePath }/gas-network`);
  }

  /**
   *
   * Returns a list of gas stations
   * @param body
   */
  public gasStationGet(body: HttpParams): Observable<ResponseModel<GasStationModel[]>> {
    return this.httpClient.get<ResponseModel<GasStationModel[]>>(`${ this.basePath }/gas-station`,
      {
        params: body
      }
    );
  }

  /**
   *
   * Returns a list of gas stations with network
   * @param body
   */
  public gasStationGetWithNetwork(body: HttpParams): Observable<ResponseModel<GasStationModel[]>> {

    return this.httpClient.get<ResponseModel<GasStationModel[]>>(`${ this.basePath }/gas-station?include=network`,
        {
          params: body
        }
    );
  }

  /**
   *
   * Returns a list of gas stations
   * @param body
   */
  public gasNetworkStation(id: number, body: HttpParams = null): Observable<ResponseModel<any[]>> {

    return this.httpClient.get<ResponseModel<any[]>>(`${ this.basePath }/gas-station?network_id=${id}&per_page=100`,
        {
          params: body
        }
    );
  }

  /**
   *
   * Delete gas station by station id
   * @param id Station identifier
   */
  public gasStationIdDelete(id: number): Observable<ResponseModel<null>> {
    return this.httpClient.delete<ResponseModel<null>>(`${ this.basePath }/gas-station/${ encodeURIComponent(String(id)) }`);
  }

  /**
   *
   * Retrive gas station by station id
   * @param id Station identifier
   * @param body
   */
  public gasStationIdGet(id: number, body: HttpParams = null): Observable<ResponseModel<GasStationModel>> {
    return this.httpClient.get<ResponseModel<GasStationModel>>(`${ this.basePath }/gas-station/${ encodeURIComponent(String(id)) }`,
      {
          params: body
        }
      );
  }

  /**
   *
   * Update gas station by station id
   * @param body
   * @param id Station identifier
   */
  public gasStationIdPut(body: GasStationModel, id: number): Observable<ResponseModel<GasStationModel>> {

    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling gasStationIdPut.');
    }

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling gasStationIdPut.');
    }

    return this.httpClient.put<ResponseModel<GasStationModel>>(`${ this.basePath }/gas-station/${ encodeURIComponent(String(id)) }`,
      body
    );
  }

  /**
   *
   * Create a new gas station
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public gasStationPost(body: GasStationModel, observe?: 'body', reportProgress?: boolean): Observable<ResponseModel<GasStationModel>> {

    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling gasStationPost.');
    }

    return this.httpClient.post<ResponseModel<GasStationModel>>(`${ this.basePath }/gas-station`,
      body
    );
  }

  /**
   *
   * Returns a most suitable gas stations network tariffs
   * @param rentHours
   * @param id Station identifier
   */
  public gasNetworkIdTariffBestPost(rentHours: number, id: number): Observable<ResponseModel<GasNetworkTariffModel, { total: number }>> {

    if (rentHours === null || rentHours === undefined) {
      throw new Error('Required parameter rentHours was null or undefined when calling gasNetworkIdTariffBestPost.');
    }

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling gasNetworkIdTariffBestPost.');
    }

    return this.httpClient.post<ResponseModel<GasNetworkTariffModel>>(`${this.basePath}/gas-network/${encodeURIComponent(String(id))}/tariff/best`, {
      rent_hours: rentHours
    });
  }

  /**
   *
   * Returns a list of gas stations network tariffs
   * @param id Station identifier
   */
  public gasNetworkIdTariffGet(id: number): Observable<ResponseModel<GasNetworkTariffModel>> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling gasNetworkIdTariffGet.');
    }

    return this.httpClient.get<ResponseModel<GasNetworkTariffModel>>(`${this.basePath}/gas-network/${encodeURIComponent(String(id))}/tariff`);
  }

}
